import moment from 'moment';
import {PickupLocation} from './Location';
export type ProductModifierValue = {
  id: string;
  name: string;
  price: number;
  seq: number;
  isdefault: string;
  product: string;
  calories: number;
  points?: number;
};
export type ProductModifierType = {
  id: string;
  name: string;
  sdesc: string;
  type: number;
  forced: string;
  maxsel: number;
  minsel?: number;
  vals: Array<ProductModifierValue>;
};
export type TimeSlotType = {
  time: string;
  timeString: string;
  leadTime?: number;
  momentTime?: moment.Moment;
  timezone?: string;
  date?: string;
  dateString?: string;
  dayOfWeek?: number;
};
export type TabType = {
  id: string;
  name: string;
  desc: string;
  modifiers: Array<ProductModifierType>;
};
export type MenuProductType = {
  scancode: string;
  name: string;
  description?: string;
  smallimageurl?: string;
  largeimageurl?: string;
  price: number;
  hasmodifier: string;
  tabs: Array<string>;
  id: string;
  guid: string;
  overrideDna?: string;
  pickupLocations?: Array<PickupLocation>;
  printgroups?: Array<string>;
  calories?: number;
  featuredproduct: 'Y' | 'N';
  weigh: 'Y' | 'N';
  um: string;
  RewardPoints?: number;
  rewardPoints?: number;
  points?: number;
};
export type MenuType = {
  data: Array<MenuCategoryType>;
  service: string;
  menutimelist: Array<MenuTimeType>;
  name: string;
  type: string;
  RewardPoints?: number;
};
export type MenuCategoryType = {
  longname: string;
  parent: number;
  level: number;
  name: string;
  id: number;
  isautoadd: 'Y' | 'N';
  default: boolean;
  products: Array<MenuProductType>;
  largeimageurl?: string;
  smallimageurl?: string;
};
export type MenuTimeType = {
  dayofweek: number;
  endtime: string;
  starttime: string;
};

export enum PickUpTimeType {
  ASAP = 'ASAP',
}
